import React from 'react';
import PropTypes from 'prop-types';

class Button extends React.Component {
    static propTypes = {
        icon: PropTypes.object,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        clickDelayMs: PropTypes.number,
        text: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ])
    }

    static defaultProps = {
        icon: null,
        onClick: null,
        disabled: false,
        text: "",
        className: "",
        onClickDelayMs: 2500
    }

    isUnMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            isOnClickDelayTurnOn: false
        }
    }

    componentWillUnmount() {
        this.isUnMounted = true;
    }

    isDisabled = () => this.props.disabled || this.state.isOnClickDelayTurnOn;

    onClick() {
        if (this.isDisabled()) {
            return;
        }
        this.onClickDelayTimeout(this.props.onClickDelayMs);
        this.props.onClick();
    }    

    turnOnClickDelay(bool) {
        if(this.isUnMounted){
            return;
        }
        this.setState({ isOnClickDelayTurnOn: bool });
    }

    onClickDelayTimeout(ms) {
        this.turnOnClickDelay(true);
        setTimeout(() => this.turnOnClickDelay(false), ms);
    }

    render() {
        return (
            <div
                className={"global-button " + this.props.className}
                onClick={() => this.onClick()}
                data-disabled={this.isDisabled()}
                data-visible={true}
                data-fixed={true}
            >
                <i className="global-button-icon">{this.props.icon}</i>
                <span> {this.props.text}</span>
            </div>
        )
    }
}

export default Button;